var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "my-10 mx-4 lg:mx-0"
  }, [_c('div', {
    staticClass: "flex justify-center my-10"
  }, [_c('ProfilePicture', {
    attrs: {
      "show-edit-link": true,
      "size": "max-w-40 w-40 h-40"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', {
    staticClass: "border-dashed border-gray-300 border-2 rounded-lg"
  }, [_c('div', {
    staticClass: "my-4 mx-8"
  }, [_c('p', {
    staticClass: "text-sm italic font-medium text-gray-600"
  }, [_vm._v("\n          Nom d'utilisateur\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "text-indigo-600"
  }, [_vm._v("\n          " + _vm._s((_vm.datas || {}).username) + "\n        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "my-10 w-full"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/5 2xl:mx-1/4 mx-10"
  }, [_c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "firstname",
      "libelle": "Prénom",
      "value": (_vm.datas || {}).firstname,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.firstname'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.datas.firstname = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "lastname",
      "libelle": "Nom",
      "value": (_vm.datas || {}).lastname,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.lastname'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.datas.lastname = newValue;
      }
    }
  }), _vm._v(" "), _vm.inCompany || _vm.isAdminPay ? _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "company",
      "libelle": "Entreprise",
      "disabled": ![_vm.constants.ROLE_ADMIN_ENTREPRISE, _vm.constants.ROLE_ADMIN_PAYEUR].includes(_vm.mainRole),
      "value": (_vm.datas || {}).company
    },
    on: {
      "input": function (newValue) {
        _vm.datas.company = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.inCompany || _vm.isAdminPay ? _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "function",
      "libelle": "Fonction",
      "value": (_vm.datas || {}).position
    },
    on: {
      "input": function (newValue) {
        _vm.datas.position = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isAdminPay ? _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "siret",
      "libelle": "N° SIRET",
      "maxlength": 14,
      "value": (_vm.datas || {}).siret
    },
    on: {
      "input": function (newValue) {
        _vm.datas.siret = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isAdminPay ? _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "ape",
      "libelle": "Code APE",
      "value": (_vm.datas || {}).ape
    },
    on: {
      "input": function (newValue) {
        _vm.datas.ape = newValue;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "email",
      "type": "email",
      "libelle": "Email",
      "value": (_vm.datas || {}).email,
      "error": true,
      "msg-error": ((_vm.errors || [])['user.email'] || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.datas.email = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "lg:col-span-6",
    attrs: {
      "name": "phone_number",
      "libelle": "Téléphone",
      "error": true,
      "type": "tel",
      "value": (_vm.datas || {}).phone_number
    },
    on: {
      "input": function (newValue) {
        _vm.datas.phone_number = newValue;
      }
    }
  }), _vm._v(" "), _c('input-text-area', {
    staticClass: "lg:col-span-full",
    attrs: {
      "size": "5",
      "name": "address",
      "libelle": "Adresse postale",
      "value": (_vm.datas || {}).address
    },
    on: {
      "input": function (newValue) {
        _vm.datas.address = newValue;
      }
    }
  }), _vm._v(" "), _c('password-modifier', {
    ref: "password",
    attrs: {
      "grid": "grid grid-cols-12 gap-x-4 gap-y-5",
      "password-input-size": "lg:col-span-6 col-span-full",
      "confirm-password-input-size": "lg:col-span-6 col-span-full",
      "auth-password-input-size": "lg:col-span-6 col-span-full",
      "confirm-button-size": "lg:col-span-6 col-span-full",
      "password": (_vm.datas || {}).password || '',
      "confirm-password": (_vm.datas || {}).password_confirmation || '',
      "auth-password": _vm.authPassword,
      "errors": _vm.errors
    },
    on: {
      "fillPassword": function (newValue) {
        (_vm.datas || {}).password = newValue;
      },
      "fillConfirmPassword": function (newValue) {
        (_vm.datas || {}).password_confirmation = newValue;
      },
      "fillAuthPassword": function (newValue) {
        _vm.authPassword = newValue;
      },
      "confirmNewPassword": _vm.confirmNewPassword
    }
  }), _vm._v(" "), false ? _c('div', {
    staticClass: "col-span-full flex items-center space-x-2 relative"
  }, [_c('input-text', {
    attrs: {
      "name": "affiliate_link",
      "libelle": "Lien d'affiliation",
      "value": _vm.affiliateLink,
      "disabled": true
    }
  }), _vm._v(" "), _c('action-button', {
    staticClass: "mt-5",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "libelle": "Copier",
      "icon": "copy"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.copyAffiliateLink();
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "duration-300",
      "enter-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "duration-300",
      "leave-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }
  }, [_vm.linkCopied ? _c('tag', {
    staticClass: "absolute -right-5 bottom-10",
    attrs: {
      "libelle": "lien copié",
      "text-size": "text-sm",
      "text-font": "font-light"
    }
  }) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _vm.mainRole === _vm.constants.ROLE_ADMIN_PAYEUR && _vm.user.CGV_accepted !== null ? _c('a', {
    staticClass: "flex space-x-2 items-center col-span-full text-gray-600 text-base font-normal cursor-pointer",
    attrs: {
      "href": '/cgv/' + _vm.user.id + '/conditions_generales_de_vente_acceptees_le_' + _vm.cgvDateFormatedFilename + '.pdf',
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-text"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n            Conditions générales de vente acceptées le\n            " + _vm._s(_vm.cgvDateFormated) + "\n          ")])], 1) : _vm._e(), _vm._v(" "), (_vm.mainRole === _vm.constants.ROLE_BENEFICIAIRE || _vm.$freeParticulier()) && _vm.user.CGU_accepted !== null ? _c('a', {
    staticClass: "flex space-x-2 items-center col-span-full text-gray-600 text-base font-normal cursor-pointer",
    attrs: {
      "href": '/cgu/' + _vm.user.id + '/conditions_generales_d_utilisation_acceptees_le_' + _vm.cguDateFormatedFilename + '.pdf',
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-text"
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n            Conditions générales d'utilisation acceptées le\n            " + _vm._s(_vm.cguDateFormated) + "\n          ")])], 1) : _vm._e()], 1)])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }